import ascending from "./ascending.js";
import group, { rollup } from "./group.js";
import sort from "./sort.js";
export default function groupSort(values, reduce, key) {
  return (reduce.length !== 2 ? sort(rollup(values, reduce, key), (_ref, _ref2) => {
    let [ak, av] = _ref;
    let [bk, bv] = _ref2;
    return ascending(av, bv) || ascending(ak, bk);
  }) : sort(group(values, key), (_ref3, _ref4) => {
    let [ak, av] = _ref3;
    let [bk, bv] = _ref4;
    return reduce(av, bv) || ascending(ak, bk);
  })).map(_ref5 => {
    let [key] = _ref5;
    return key;
  });
}